<script lang="ts">
	export let label: string;
</script>

<div class="text-2xs md:text-base lg:space-y-1">
	<span>{label}</span>
	<slot />
</div>
